export const PAYMENT_LINK_TYPE = {
  PAYMENT_LINK: "payment-link",
  RECURRENT: "recurrent",
};

export const EXTENSION_TYPE = {
  COURSE: "course",
  FORMATION: "formation",
  MBA: "mba",
};

export const PAYMENT_METHOD = {
  ALL: "all",
  CREDIT_CARD: "cartao_de_credito",
  PIX: "pix",
};

export const FORM_FIELD = {
  LINK_TYPE: "link-type",
  USER_ID: "user-id",
  PRODUCT_ID: "product-id",
  PAYMENT_METHOD: "payment-method",
  CYCLES: "cycles",
  CYCLE_PRICE: "cycle-price",
  MAX_INSTALLMENTS: "max-installment",
  TOTAL: "total",
  EXPIRATION_DATE: "expiration-date",
  EXTENSION_DAYS: "extension-days",
  IS_LIFETIME: 'is_lifetime'
};

export const paymentMethods = [
  { id: PAYMENT_METHOD.ALL, name: "Todos" },
  { id: PAYMENT_METHOD.CREDIT_CARD, name: "Cartão de Crédito" },
  { id: PAYMENT_METHOD.PIX, name: "Pix" },
];

export const paymentLinkTypePaymentMethods = {
  [PAYMENT_LINK_TYPE.PAYMENT_LINK]: paymentMethods.filter((method) =>
    [PAYMENT_METHOD.CREDIT_CARD, PAYMENT_METHOD.PIX].includes(method.id)
  ),
  [PAYMENT_LINK_TYPE.RECURRENT]: paymentMethods.filter((method) =>
    [PAYMENT_METHOD.CREDIT_CARD].includes(method.id)
  ),
};

export const paymentLinkRequiredFields = [
  FORM_FIELD.USER_ID,
  FORM_FIELD.PRODUCT_ID,
  FORM_FIELD.EXTENSION_DAYS,
  FORM_FIELD.PAYMENT_METHOD,
  FORM_FIELD.MAX_INSTALLMENTS,
  FORM_FIELD.TOTAL,
  FORM_FIELD.EXPIRATION_DATE,
];

export const recurrentLinkRequiredFields = [
  FORM_FIELD.PRODUCT_ID,
  FORM_FIELD.EXTENSION_DAYS,
  FORM_FIELD.CYCLES,
  FORM_FIELD.CYCLE_PRICE
];
